import { render, staticRenderFns } from "./frequent.vue?vue&type=template&id=d862f47e&scoped=true"
import script from "./frequent.vue?vue&type=script&lang=js"
export * from "./frequent.vue?vue&type=script&lang=js"
import style0 from "./frequent.vue?vue&type=style&index=0&id=d862f47e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d862f47e",
  null
  
)

export default component.exports